import React, { useEffect, useState } from 'react';
import { ChevronDown, ChevronRight, ExternalLink } from 'lucide-react';
import { Sidebar } from '@/components/Sidebar';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { axiosInstance } from '../App';
import { toast } from 'sonner';

const money = (value) => Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const DRELedger = ({ user, onLogout }) => {
  const company = JSON.parse(localStorage.getItem('company') || '{}');
  const [competence, setCompetence] = useState(new Date().toISOString().slice(0, 7));
  const [data, setData] = useState(null);
  const [expanded, setExpanded] = useState({});

  useEffect(() => {
    if (!company.id || !competence) return;
    axiosInstance.get(`/contabil/dre-ledger/${company.id}`, { params: { competencia: competence } })
      .then(({ data: response }) => setData(response))
      .catch((error) => toast.error(error.response?.data?.detail || 'Não foi possível calcular a DRE Ledger'));
  }, [company.id, competence]);

  return <div className="flex min-h-screen bg-zinc-950 text-white">
    <Sidebar user={user} onLogout={onLogout} />
    <main className="flex-1 p-4 md:p-8 overflow-x-auto">
      <div className="flex flex-wrap justify-between items-end gap-4 mb-6">
        <div><h1 className="text-2xl font-bold">DRE CONTÁBIL — LEDGER — EXPERIMENTAL</h1><p className="text-zinc-400">A DRE oficial permanece inalterada.</p></div>
        <label className="text-sm">Competência<Input className="mt-1 bg-zinc-900" type="month" value={competence} onChange={(e) => setCompetence(e.target.value)} /></label>
      </div>
      {data && <>
        <div className="flex flex-wrap gap-2 mb-4">
          <Badge className={data.integrity.status === 'INTEGRO' ? 'bg-emerald-700' : 'bg-red-700'}>{data.integrity.status}</Badge>
          <Badge className={data.reconciliation.status === 'RECONCILIADO' ? 'bg-emerald-700' : 'bg-red-700'}>{data.reconciliation.status}</Badge>
          <Badge className="bg-violet-700">CONTRATO v{data.contract_version}</Badge>
        </div>
        {!!data.blockers.length && <Card className="mb-4 bg-red-950/30 border-red-800"><CardHeader><CardTitle>Bloqueadores</CardTitle></CardHeader><CardContent>{data.blockers.map((item) => <p key={item.account_id}>{item.code}: {item.account_code} — {item.account_name}</p>)}</CardContent></Card>}
        <div className="border border-zinc-800 rounded-lg overflow-hidden min-w-[720px]">
          <table className="w-full text-sm"><thead className="bg-zinc-900"><tr><th className="text-left p-3">Linha</th><th className="text-right p-3">Valor</th></tr></thead>
            <tbody>{data.lines.map((line) => <React.Fragment key={line.key}>
              <tr className={`border-t border-zinc-800 ${line.kind !== 'DETAIL' ? 'font-bold bg-zinc-900/60' : ''}`}>
                <td className="p-3"><button disabled={!line.accounts.length} className="mr-2 disabled:opacity-0" onClick={() => setExpanded(value => ({ ...value, [line.key]: !value[line.key] }))}>{expanded[line.key] ? <ChevronDown size={15} /> : <ChevronRight size={15} />}</button>{line.label}</td>
                <td className="p-3 text-right">{money(line.value)}</td>
              </tr>
              {expanded[line.key] && line.accounts.map((account) => <tr key={account.account_id} className="border-t border-zinc-900 text-zinc-300">
                <td className="py-2 pl-12">{account.code} — {account.name} <a href={`/contabil/balancete?competencia=${competence}`} className="inline-flex ml-2 text-blue-400" title="Abrir balancete"><ExternalLink size={13} /></a></td>
                <td className="p-2 text-right">{money(account.value)}</td>
              </tr>)}
            </React.Fragment>)}</tbody>
          </table>
        </div>
        <Card className="mt-5 bg-zinc-900 border-zinc-800"><CardHeader><CardTitle>Reconciliação com o balancete</CardTitle></CardHeader><CardContent className="grid md:grid-cols-3 gap-3"><div>DRE: {money(data.reconciliation.dre_ledger_result)}</div><div>Balancete: {money(data.reconciliation.trial_balance_result)}</div><div>Diferença: {money(data.reconciliation.difference)}</div></CardContent></Card>
        {data.legacy_comparison && <Card className="mt-5 bg-zinc-900 border-zinc-800"><CardHeader><CardTitle>Comparação temporária com a DRE legada</CardTitle></CardHeader><CardContent><p>{data.legacy_comparison.divergences} linha(s) divergente(s). Esta comparação não integra o cálculo contábil.</p></CardContent></Card>}
      </>}
    </main>
  </div>;
};

export default DRELedger;
